import React, {Fragment, useRef} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import LookMobileFooterButton from "./lookMobileFooterButton";
import LookFilters from "../lookFilters/lookFilters";
import LookListFooter from "../../list/lookListFooter";
import LookListContent from "../../list/lookListContent";
import {setLookPageOpened} from "../../../../actions/lookFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {ROUTES} from "../../../../routes";
import LookFeatureInfo from "./lookFeature/lookFeatureInfo";
import LookMainWizardSelectedSteps from "./lookMainWizardSelectedSteps";
import LookWizardCompletedAlertModal from "./lookWizard/lookWizardCompletedAlertModal";
import LookCompatabilitySection from "./lookCompatability/lookCompatabilitySection";

const LookMobile = (props) => {

  const {setLookPageOpened, lookPageOpened, history, visualizersLoadedLength} = props;

  const wizRef = useRef();

  const lookListCloseClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookMobileListClose);
    setLookPageOpened("");
    history.push(ROUTES.home);
  }

  return (
    <Fragment>
      <LookMobileFooterButton/>
      <LookFilters/>
      <LookCompatabilitySection/>
      <div className={"ll-overlay" + (lookPageOpened === ROUTES.list && visualizersLoadedLength ? " ll-overlay--opened" : "")}>
        {lookPageOpened === ROUTES.list ? <LookListContent onBackClick={lookListCloseClick}/> : null}
      </div>
      <LookListFooter/>
      <LookFeatureInfo/>
      <LookMainWizardSelectedSteps/>
      <div className="lw-alert-pin" ref={wizRef}>
        <LookWizardCompletedAlertModal anchorEl={wizRef}/>
      </div>
    </Fragment>
  )
};


const mapStateToProps = (store) => {
  const {lookPageOpened} = store.lookState;
  const {visualizersLoaded} = store.serverState;

  return {
    lookPageOpened,
    visualizersLoadedLength: visualizersLoaded.length
  };
};

const mapDispatchToProps = {
  setLookPageOpened
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookMobile)
)
